/**
 * SiteContentPage — migrated from Editorial-desk · "Edit content" tab.
 * Wraps the existing `Editor` component (marketing hero copy editor).
 */
import React from "react";
import { useContent } from "@/lib/content";
import { Editor } from "@/pages/AdminDashboard";
import LegacyHost from "@/pages/admin/os/LegacyHost";

export default function SiteContentPage() {
  const { content, loading, refresh } = useContent();
  return (
    <LegacyHost
      title="Site Content"
      migratedFrom="Editorial desk · Edit content"
      testid="os-system-content"
    >
      {loading ? (
        <p className="eyebrow">Loading…</p>
      ) : (
        <Editor initial={content} onSaved={refresh} />
      )}
    </LegacyHost>
  );
}
